/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerUpdateMutationRequest, DocumentsControllerUpdateMutationResponse, DocumentsControllerUpdatePathParams, DocumentsControllerUpdate400, DocumentsControllerUpdate401, DocumentsControllerUpdate403, DocumentsControllerUpdate404 } from "../../models/documentsController/DocumentsControllerUpdate";

function getDocumentsControllerUpdateUrl(id: DocumentsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/documents/${id}` as const }  
  return res
}

/**
 * @summary Update a document
 * {@link /api/v1/documents/:id}
 */
export async function documentsControllerUpdate(id: DocumentsControllerUpdatePathParams["id"], data?: DocumentsControllerUpdateMutationRequest, config: Partial<RequestConfig<DocumentsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DocumentsControllerUpdateMutationResponse, ResponseErrorConfig<DocumentsControllerUpdate400 | DocumentsControllerUpdate401 | DocumentsControllerUpdate403 | DocumentsControllerUpdate404>, DocumentsControllerUpdateMutationRequest>({ method : "PATCH", url : getDocumentsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}